import Image from 'next/image';
import styled from 'styled-components';
import { TextStyles } from '@/constants';
import { Typography } from '@/components';

const ellipsisStyles = `
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

// Below is styling for PeopleVariant.Default and PeopleVariant.WithQuotes
export const PeopleContainer = styled.div`
  width: 100%;
  max-height: 444px;
  padding: ${({ theme }) => `${theme.spacing[24]} 0`};
  display: flex;
  flex-direction: column;
  position: relative;

  ::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 1px;
    background: ${({ theme }) => theme.colors.surface04};
  }

  ${({ theme }) => theme.mediaBreakpointUp.md} {
    max-height: 236px;
    flex-direction: row;
  }
`;

export const PeopleLinkWrapper = styled.a.attrs({ target: '_blank' })``;

export const PeopleImage = styled(Image).attrs({
  width: 120,
  height: 120,
  unoptimized: true,
})(({ theme }) => ({
  objectFit: 'cover',
  objectPosition: 'center center',
  borderRadius: 4,
  marginBottom: theme.spacing[8],
  transition: '0.4s',
  cursor: 'pointer',

  ':hover': {
    opacity: '80%',
  },

  [`${theme.mediaBreakpointUp.md}`]: {
    marginBottom: 0,
  },
}));

export const PeopleContainWrapper = styled.div`
  ${({ theme }) => theme.mediaBreakpointUp.md} {
    padding-left: ${({ theme }) => theme.spacing[24]};
  }
`;

export const PeopleName = styled(Typography).attrs({
  variant: TextStyles['Heading 5'],
})`
  color: ${({ theme }) => theme.colors.highEmphasisBlack};
`;

export const PeopleNameAsLink = styled(PeopleName)`
  ${ellipsisStyles}
  -webkit-line-clamp: 1;
  color: ${({ theme }) => theme.colors.blue};
  transition: 0.4s;
  cursor: pointer;

  :hover {
    color: ${({ theme }) => theme.colors.blueHover};
  }
`;

export const PeopleSubHeader = styled(Typography).attrs({
  variant: TextStyles['Heading 6'],
})`
  ${ellipsisStyles}
  -webkit-line-clamp: 1;
  color: ${({ theme }) => theme.colors.mediumEmphasisBlack};
`;

export const PeopleJobPosition = styled(Typography).attrs({
  variant: TextStyles['Body Text Small'],
})`
  color: ${({ theme }) => theme.colors.mediumEmphasisBlack};
  margin-top: ${({ theme }) => theme.spacing[4]};
`;

export const PeopleDescription = styled(Typography).attrs({
  variant: TextStyles['Body Text Large'],
})`
  color: ${({ theme }) => theme.colors.mediumEmphasisBlack};
  padding-top: ${({ theme }) => theme.spacing[16]};
  display: -webkit-box;
  -webkit-line-clamp: 6;
  -webkit-box-orient: vertical;
  overflow: hidden;
  margin-bottom: ${({ theme }) => theme.spacing[16]};

  ${({ theme }) => theme.mediaBreakpointUp.md} {
    -webkit-line-clamp: 4;
    margin-bottom: ${({ theme }) => theme.spacing[8]};
    padding-top: ${({ theme }) => theme.spacing[8]};
  }
`;
